<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 12 9">
    <circle cx="1.28345" cy="0.845955" r="0.619392" :class="colorClass" />
    <circle cx="1.28345" cy="4.20911" r="0.619392" :class="colorClass" />
    <circle cx="1.28345" cy="7.48194" r="0.619392" :class="colorClass" />

    <rect x="3.32031" y="0.404419" width="8.67149" height="0.973331" rx="0.486665" :class="colorClass" />
    <rect x="3.32031" y="3.76611" width="8.67149" height="0.973331" rx="0.486665" :class="colorClass" />
    <rect x="3.32031" y="7.03894" width="8.67149" height="0.973331" rx="0.486665" :class="colorClass" />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
